import { Box } from '@zillow/constellation-10';
import AddMessageSkeleton from '../AddMessage/skeleton';
import ConversationNavSkeleton from '../ConversationNav/skeleton';
import { MessageListContentsSkeleton } from '../MessageListItems/skeleton';

export const MessageListSkeleton = (): JSX.Element => {
  return (
    <>
      <Box
        css={{
          width: '100%',
          paddingLeft: 'default',
          paddingRight: 'tight',
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <MessageListContentsSkeleton />
      </Box>
      <AddMessageSkeleton />
    </>
  );
};

export const MessageListEmptyContainerSkeleton = (): JSX.Element => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        flex: 1,
      }}
    >
      <ConversationNavSkeleton />
      <MessageListSkeleton />
    </Box>
  );
};
